import { CreatedByUser, Program, Project } from "@/api/query/useProjectQuery";
import { FIELDS } from "@/api/types/enums";
import InputText from "@/components/common/InputText";
import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import Select, { SingleValue } from "react-select";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { Options } from "@/components/views/ganntView/GanttView";
import CalendarSvg from "../../assets/svg/Calendar.svg";
import CalenderNew from "../../assets/svg/calendarWhite.svg";
import CalenderBlackSvg from "../../assets/svg/calendarBlack.svg";
import CrossSvg from "../../assets/svg/crossNew.svg";
import DownArrow from "../../assets/svg/DownArrow.svg";
import DownArrowWhite from "../../assets/svg/downArrowWhite.svg";
import SearchSvg from "../../assets/svg/search.svg";
import { DateRange } from "react-day-picker";
import { useSearchParams } from "react-router-dom";
import {
  ProjectStatusEnumValue,
  UserRoleEnumValue,
} from "@backend/src/schemas/enums";
import { Calendar } from "@/components/ui/calendar";
import dateFormater from "@/helperFuntions/dateFormater";
import useDebounce from "@/hooks/useDebounce";
import useAllPortfoliosQuery, {
  Portfolios,
} from "@/api/query/useAllPortFoliosQuery";
type Filter = {
  project: Project[] | undefined;
  fieldToShow: FIELDS[];
  filteredData: (data: Project[] | undefined) => void;
  view?: string;
  appleed?: (data: boolean) => void;
};
export type TaskFilterRef = {
  callFilter: () => void;
};
const ProjectFilter = (props: Filter) => {
  const CPILabels = [
    "SIGNIFICANT_BUDGET",
    "MODERATE_BUDGET",
    "ON_BUDGET",
    "UNDER_BUDGET",
  ] as const;
  const SPILabels = [
    "SIGNIFICANT_DELAY",
    "MODERATE_DELAY",
    "ON_TIME",
    "AHEAD_OF_SCHEDULE",
  ] as const;
  const [popOverCLose, setPopOverCLose] = useState(false);
  const [filterApplyed, setFilterApplyed] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [filter, setFilter] = useState<{
    projectManager: SingleValue<Options> | null;
    status: SingleValue<Options> | null;
    date: DateRange | undefined;
    delay: string;
    budget: string;
    portfolioId: string;
    programId: string;
  }>({
    projectManager: null,
    status: null,
    date: undefined,
    delay: "",
    portfolioId: "",
    programId: "",
    budget: "",
  });
  useEffect(() => {
    if (searchParams.get("status")) {
      setFilter((prev) => ({
        ...prev,
        status: {
          label: searchParams.get("status") ?? "",
          value: searchParams.get("status") ?? "",
        },
      }));
    }
    if (searchParams.get("delay")) {
      setFilter((prev) => ({
        ...prev,
        delay: searchParams.get("delay") ?? "",
      }));
    }
    if (searchParams.get("budget")) {
      setFilter((prev) => ({
        ...prev,
        budget: searchParams.get("budget") ?? "",
      }));
    }
    ApplyFilter();
  }, [props.project]);

  useEffect(() => {
    ApplyFilter();
  }, [searchParams]);

  const projectManagerName = (data: CreatedByUser): string => {
    if (data.firstName && data.lastName) {
      return data.firstName + " " + data.lastName;
    }
    return data.email;
  };

  const projectManager = (): Options[] | undefined => {
    const projectManagerData: Options[] = [
      { label: t("select_manager"), value: "" },
    ];
    props.project?.forEach((item) => {
      const hasPM = item.assignedUsers.some(
        (d) => d.projectRole === UserRoleEnumValue.PROJECT_MANAGER
      );

      item.assignedUsers
        .filter(
          (d) =>
            (hasPM && d.projectRole === UserRoleEnumValue.PROJECT_MANAGER) ||
            (!hasPM && d.projectRole === UserRoleEnumValue.ADMINISTRATOR)
        )
        .forEach((element) => {
          const val = element.user.email;
          if (
            !projectManagerData.some(
              (i) =>
                i.value === val &&
                element.projectRole !== UserRoleEnumValue.TEAM_MEMBER
            )
          ) {
            projectManagerData.push({
              label: projectManagerName(element.user),
              value: val,
            });
          }
        });
    });

    return projectManagerData;
  };

  const status = (): Options[] | undefined => {
    const statusData: Options[] = [{ label: t("select_status"), value: "" }];
    props.project?.forEach((item) => {
      if (!statusData.some((i) => i.value === item.status)) {
        statusData.push({
          label: t(item.status),
          value: item.status,
        });
      }
    });
    return statusData;
  };
  const [searchString, setSearchString] = useDebounce("", 400);

  useEffect(() => {
    props.filteredData(
      searchString
        ? props.project?.filter((p) =>
            p.projectName.toLowerCase().includes(searchString.toLowerCase())
          )
        : props.project
    );
  }, [searchString]);

  const reactSelectStyle = {
    control: (
      provided: Record<string, unknown>,
      state: { isFocused: boolean }
    ) => ({
      ...provided,
      border: "1px solid #E7E7E7",
      paddingTop: "0.2rem",
      paddingBottom: "0.2rem",
      outline: state.isFocused ? "2px solid #299d91" : "0px solid #E7E7E7",
      boxShadow: state.isFocused ? "0px 0px 0px #299d91" : "none",
      "&:hover": {
        outline: "2px solid #299d91",
        boxShadow: "0px 0px 0px #299d91",
      },
    }),
    option: (
      provided: Record<string, unknown>,
      state: { isSelected: boolean }
    ) => ({
      ...provided,
      color: state.isSelected ? "white" : "black",
      background: state.isSelected ? "#299d91" : "white",
      "&:hover": {
        color: "white",
        background: "#299d9199",
      },
    }),
  };
  const ApplyFilter = () => {
    let filtered = props.project || [];

    if (filter.projectManager?.value) {
      filtered = filtered.filter((proj) =>
        proj.assignedUsers.some(
          (au) => au.user.email === filter.projectManager?.value
        )
      );
    }

    if (filter.status?.value) {
      filtered = filtered.filter(
        (proj) => proj.status === filter.status?.value
      );
    }

    if (filter.delay) {
      filtered = filtered?.filter((p) => {
        if (p.status === ProjectStatusEnumValue.ACTIVE) {
          if (filter.delay == "SIGNIFICANT_DELAY") {
            return typeof p.spi === "number" && p.spi < 80;
          } else if (filter.delay == "MODERATE_DELAY") {
            return typeof p.spi === "number" && p.spi >= 80 && p.spi < 95;
          } else if (filter.delay == "ON_TIME") {
            return typeof p.spi === "number" && p.spi >= 95 && p.spi <= 100;
          } else if (filter.delay == "AHEAD_OF_SCHEDULE") {
            return typeof p.spi === "number" && p.spi > 100;
          }
        }
        return false;
      });
    }
    // console.log(filter.budget);
    
    if (filter.budget) {
      filtered = filtered?.filter((p) => {
        if (typeof p.cpi === "number") {
          if (filter.budget == "SIGNIFICANT_BUDGET") {
            return p.cpi < 80;
          } else if (filter.budget == "MODERATE_BUDGET") {
            return p.cpi >= 80 && p.cpi < 95;
          } else if (filter.budget == "ON_BUDGET") {
            return p.cpi >= 95 && p.cpi <= 100;
          } else if (filter.budget == "UNDER_BUDGET") {
            return p.cpi > 100;
          }
        }
        return false;
      });
    }
    if (filter?.portfolioId) {
      filtered = filtered?.filter((p) => {
        if (p?.portfolio?.portfolioId === filter?.portfolioId) {
          return true;
        }
        return false;
      });
    }
    if (filter?.programId) {
      filtered = filtered?.filter((p) => {
        if (p?.program?.programId === filter.programId) {
          return true;
        }
        return false;
      });
    }

    if (filter.date?.from && filter.date?.to) {
      const fromDate = new Date(filter.date.from).setHours(0, 0, 0, 0);
      const toDate = new Date(filter.date.to).setHours(23, 59, 59, 999);
      filtered = filtered.filter((proj) => {
        const endDate = new Date(proj.estimatedEndDate || "").getTime();
        return endDate >= fromDate && endDate <= toDate;
      });
    }

    // Update search params
    // const updatedParams: Record<string, string> = {};
    // if (filter.status?.value) updatedParams.status = filter.status.value;
    // if (filter.delay) updatedParams.delay = filter.delay;
    // setSearchParams(updatedParams);
    const isFilterd = Boolean(
      filter.projectManager?.value ||
        filter.status?.value ||
        filter.delay ||
        filter.date?.from ||
        filter.date?.to ||
        filter.portfolioId ||
        filter.programId ||
        filter.budget
    );
    if (isFilterd) {
      setFilterApplyed(true);
      setPopOverCLose(false);
    } else {
      setFilterApplyed(false);
      setPopOverCLose(false);
    }
    props.appleed?.(isFilterd);
    props.filteredData(filtered);
    /*************  ✨ Windsurf Command ⭐  *************/
    /**
     * Resets the filter state and the search params to their initial values.
     * Additionally, sets filterApplied to false, applies the filter to the project data and notifies the parent component.
     */
    /*******  54ae64ef-bdda-46d0-8064-7607442e6e16  *******/
  };

  const resetFilter = () => {
    setFilter({
      projectManager: null,
      date: undefined,
      status: null,
      delay: "",
      portfolioId: "",
      programId: "",
      budget: "",
    });
    setSearchParams({});
    setFilterApplyed(false);
    props.filteredData(props.project);
    props.appleed?.(false);
  };

  const [portfolios, setPortfolios] = useState<Options[]>([]);
  const [programs, setPrograms] = useState<Options[]>([]);
  const [allPortfolios, setAllPortfolios] = useState<{
    programs: Program[];
    portfolios: Portfolios[];
  }>();
  const allPortfoliosQuery = useAllPortfoliosQuery();
  useEffect(() => {
    const data = allPortfoliosQuery.data?.data.data;
    setAllPortfolios(data);
    setPortfolios([
      { label: t("Select portfolio"), value: "" },
      ...(data?.portfolios ?? []).map(({ portfolioId, portfolioName }) => ({
        value: portfolioId,
        label: portfolioName,
      })),
    ]);
  }, [allPortfoliosQuery.data?.data.data, t]);
  useEffect(() => {
    const selectedPortfolio = allPortfolios?.portfolios.find(
      ({ portfolioId }) => portfolioId == filter?.portfolioId
    );
    if (selectedPortfolio && selectedPortfolio?.programs?.length) {
      setPrograms([
        { label: t("Select program"), value: "" },
        ...(selectedPortfolio?.programs?.map(({ programId, programName }) => ({
          value: programId,
          label: programName,
        })) ?? []),
      ]);
    } else {
      setPrograms([
        { label: t("Select program"), value: "" },
        ...(allPortfolios?.programs?.map(({ programId, programName }) => ({
          value: programId,
          label: programName,
        })) ?? []),
      ]);
    }
  }, [filter.portfolioId, allPortfoliosQuery.data?.data.data, allPortfolios]);
  return (
    <div>
      <div className="flex w-full justify-between items-center gap-2">
        <div className="flex justify-between w-full gap-2 text-gray-500">
          <div className="flex justify-between items-center gap-6 px-3 w-full relative">
            <div>
              <Popover open={popOverCLose}>
                <PopoverTrigger className="w-full ">
                  <Button
                    variant={"outline"}
                    className="w-28 h-10 rounded-xl px-2"
                    style={{
                      backgroundColor:
                        filterApplyed || searchParams.size > 0 ? "#299d91" : "",
                      color:
                        filterApplyed || searchParams.size > 0 ? "#ffffff" : "",
                    }}
                    onClick={() => setPopOverCLose(!popOverCLose)}
                  >
                    <div className="flex justify-between gap-5 items-center">
                      <div className="flex items-center justify-between gap-1">
                        <div className="w-5">
                          <img
                            src={
                              filterApplyed || searchParams.size > 0
                                ? CalenderNew
                                : CalenderBlackSvg
                            }
                          />
                        </div>
                        {t("Filters")}{" "}
                      </div>
                      <div className="w-5 ">
                        <img
                          src={
                            filterApplyed || searchParams.size > 0
                              ? DownArrowWhite
                              : DownArrow
                          }
                        />
                      </div>
                    </div>
                  </Button>
                </PopoverTrigger>
                <PopoverContent className=" absolute bg-white shadow-lg mr-5 max-h-screen overflow-y-auto -translate-x-[20%] !w-fit">
                  <div className="p-3 !w-80 flex flex-col gap-3 ">
                    <div>
                      <div className="text-lg font-semibold">
                        {t("Filters")}
                      </div>
                      <hr />
                    </div>
                    {props.project && (
                      <div className="flex flex-col gap-2">
                        <div className="">
                          <Select
                            className=""
                            placeholder={t("Select portfolio")}
                            options={portfolios}
                            value={portfolios.find(
                              (t) => t.value == filter.portfolioId
                            )}
                            onChange={(e) => {
                              const val = e as Options;
                              setFilter((prev) => ({
                                ...prev,
                                portfolioId: val?.value,
                              }));
                            }}
                            styles={reactSelectStyle}
                          ></Select>
                        </div>
                        <div>
                          <Select
                            className=""
                            placeholder={t("Select Program")}
                            options={programs}
                            value={programs.find(
                              (t) => t.value == filter.programId
                            )}
                            onChange={(e) => {
                              const val = e as Options;
                              setFilter((prev) => ({
                                ...prev,
                                programId: val?.value,
                              }));
                            }}
                            styles={reactSelectStyle}
                          ></Select>
                        </div>
                        <div className="">
                          <Select
                            className="p-0  w-full "
                            value={
                              filter.projectManager || {
                                label: t("select_manager"),
                                value: "",
                              }
                            }
                            options={projectManager()}
                            onChange={(e) =>
                              setFilter((prev) => ({
                                ...prev,
                                projectManager: e,
                              }))
                            }
                            placeholder={t("select_manager")}
                            styles={reactSelectStyle}
                          />
                        </div>
                        <div className="">
                          <Select
                            value={
                              filter.status || {
                                label: t("select_status"),
                                value: "",
                              }
                            }
                            className="p-0  w-full "
                            options={status()}
                            onChange={(e) =>
                              setFilter((prev) => ({ ...prev, status: e }))
                            }
                            placeholder={t("select_status")}
                            styles={reactSelectStyle}
                          />
                        </div>
                        <div className="w-full">
                          <Select
                            value={
                              SPILabels.map((s) => {
                                return { label: t(s), value: s };
                              }).find((s) => s.value == filter.delay) || {
                                label: t("select_delay"),
                                value: "",
                              }
                            }
                            className="p-0  w-full "
                            options={[
                              { label: t("select_delay"), value: "" },
                              ...SPILabels.map((s) => {
                                return { label: t(s), value: s };
                              }),
                            ]}
                            onChange={(e) =>
                              setFilter((prev) => ({
                                ...prev,
                                delay: e ? e.value : "",
                              }))
                            }
                            placeholder={t("select_delay")}
                            styles={reactSelectStyle}
                          />
                        </div>
                        <div className="w-full">
                          <Select
                            value={
                              CPILabels.map((s) => {
                                return { label: t(s), value: s };
                              }).find((s) => s.value == filter.budget) || {
                                label: t("select_budget"),
                                value: "",
                              }
                            }
                            className="p-0  w-full "
                            options={[
                              { label: t("select_budget"), value: "" },
                              ...CPILabels.map((s) => {
                                return { label: t(s), value: s };
                              }),
                            ]}
                            onChange={(e) =>
                              setFilter((prev) => ({
                                ...prev,
                                budget: e ? e.value : "",
                              }))
                            }
                            placeholder={t("select_budget")}
                            styles={reactSelectStyle}
                          />
                        </div>
                        <div className="w-full">
                          <Popover>
                            <PopoverTrigger className="w-full">
                              <Button
                                variant={"outline"}
                                className="w-full h-11 py-1"
                              >
                                <div className="flex justify-between items-center w-full text-gray-400 font-normal">
                                  {filter.date
                                    ? `${dateFormater(
                                        filter.date.from ?? new Date()
                                      )}-
                                              ${dateFormater(
                                                filter.date.to ?? new Date()
                                              )}`
                                    : t("end_date")}
                                  <img src={CalendarSvg} width={20} />
                                </div>
                              </Button>
                            </PopoverTrigger>
                            <PopoverContent className="z-50 bg-white ">
                              <div>
                                <Calendar
                                  mode="range"
                                  selected={filter.date}
                                  onSelect={(e) =>
                                    setFilter((prev) => ({ ...prev, date: e }))
                                  }
                                  className="rounded-md border"
                                />
                              </div>
                            </PopoverContent>
                          </Popover>
                        </div>
                      </div>
                    )}
                    {props.fieldToShow.length != 0 && (
                      <div className="w-full flex gap-2">
                        <Button
                          className="w-full mt-4"
                          variant={"destructive"}
                          onClick={() => setPopOverCLose(false)}
                        >
                          {t("close")}
                        </Button>
                        <Button
                          className="w-full mt-4"
                          variant={"primary_outline"}
                          onClick={ApplyFilter}
                        >
                          {t("apply")}
                        </Button>
                      </div>
                    )}
                  </div>
                </PopoverContent>
              </Popover>
            </div>
            {(filterApplyed || searchParams.size > 0) && (
              <div>
                <Button
                  size={"sm"}
                  className="w-5 h-5 rounded-[50%] px-2 bg-[#EA4335] hover:bg-[#EA4335] absolute left-28  bottom-7"
                  variant={"outline"}
                  onClick={resetFilter}
                >
                  <div className="flex items-center justify-between gap-2 ">
                    <div className="w-2">
                      <img src={CrossSvg} className="m-auto" />
                    </div>
                  </div>
                </Button>
              </div>
            )}
            <div className="w-full flex gap-2 relative items-center">
              <InputText
                className="pl-11 pr-3 mt-0 h-10 w-56 border-primary-500/5 placeholder:text-sm bg-primary-500/5 rounded-md focus:outline-primary-700"
                onChange={(e) => setSearchString(e.target.value)}
                placeholder={t("search_project_by_name")}
              />
              <img
                src={SearchSvg}
                className="absolute h-5 left-3 top-3"
                width={"20px"}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectFilter;
